import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = {
  isPending: false,
  isSuccessful: false,
  isFailure: false,
};

const reduceState = createStateReducer(initialState, {
  [events.changeProfilePictureRequested]: setRequestStateToPending,
  [events.changeProfilePictureSucceeded]: setRequestStateToSuccess,
  [events.changeProfilePictureFailed]: setRequestStateToFailure,
});

export type { State, Selector };

export { reduceState, initialState, createSelector };
